var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhiteUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.726,
    height: 10.078,
    viewBox: "0 0 16.726 10.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M8.363,10.078a1.71,1.71,0,0,1-1.213-.5L.5,2.928A1.715,1.715,0,0,1,2.928.5L8.363,5.937,13.8.5a1.715,1.715,0,1,1,2.426,2.426L9.576,9.576A1.71,1.71,0,0,1,8.363,10.078Z",
    transform: "translate(16.726 10.078) rotate(180)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhiteUp);
export default __webpack_public_path__ + "static/media/arrowWhite-up.96c3f5359e908ebddddf756b007d4ea9.svg";
export { ForwardRef as ReactComponent };